import React from 'react';

const EMIDetailsDialogUI = ({ isOpen, onClose, details }) => {
  if (!details || !details.length) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day}-${month}-${year}`;
  };

  const parseDetail = (detail) => {
    const parts = detail.split(',');
    if (parts.length !== 5) {
      console.warn("Skipping invalid detail string:", detail);
      return null;
    }

    const [amount, scheduleDate, paid, defaultAmt /* status */] = parts;
    return { amount, scheduleDate, paid, defaultAmt };
  };

  const convertPaiseToRupee = (str) => {
    const num = Number(str);
    return isNaN(num) ? 0 : num / 100;
  };

  let totalAmount = 0;
  let totalPaidAmount = 0;
  let totalDefaultAmount = 0;

  return (
    <div className='popup' style={isOpen ? { display: 'flex' } : { display: 'none' }}>
      <div className='popup-inner'>
        <div className='g_flex_h'>
          <h2>EMI Due Details</h2>
          <button
            style={{ border: 'none', background: 'none', fontSize: '24px', cursor: 'pointer' }}
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        <table className='popup-table'>
          <thead>
            <tr>
              <th>Amount Due</th>
              <th>Due Date</th>
              <th>Amount Paid</th>
              <th>Default Amount</th>
            </tr>
          </thead>
          <tbody>
            {details.map((detail, index) => {
              const parsed = parseDetail(detail);
              if (!parsed) return null;

              const { amount, scheduleDate, paid, defaultAmt } = parsed;

              const parsedAmount = convertPaiseToRupee(amount);
              const parsedPaid = convertPaiseToRupee(paid);
              const parsedDefault = convertPaiseToRupee(defaultAmt);

              totalAmount += parsedAmount;
              totalPaidAmount += parsedPaid;
              totalDefaultAmount += parsedDefault;

              return (
                <tr key={index}>
                  <td>{parsedAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                  <td>{formatDate(scheduleDate)}</td>
                  <td>{parsedPaid.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                  <td>{parsedDefault.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                </tr>
              );
            })}
            {/* Totals Row */}
            <tr style={{ fontWeight: 'bold' }}>
              <td style={{ color: '#cc4444' }}>
                {totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </td>
              <td></td>
              <td style={{ color: '#cc4444' }}>
                {totalPaidAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </td>
              <td style={{ color: '#cc4444' }}>
                {totalDefaultAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EMIDetailsDialogUI;
